import superagent from "superagent";
import Cookies from "universal-cookie";
// eslint-disable-next-line import/no-extraneous-dependencies
import { saveAs } from "file-saver";
import { IS_LOADING, THROW_ERROR, THROW_SUCCESS } from "../../../store/constants";
import { base_url } from "../../../utils/constants";

const cookie = new Cookies();

export const degrageUserToBasic = (user_id, getUsers, setIsLoading) => (dispatch) => {
  dispatch({ type: IS_LOADING, payload: true });
  return superagent
    .get(`${base_url}admin/cancel-user-subscription?user_id=${user_id}&type=BASIC`)
    .set("accept", "application/json")
    .set("Authorization", cookie.get("user_token"))
    .end((err, res) => {
      if (res) {
        if (res.body.status) {
          dispatch({ type: THROW_SUCCESS, payload: res.body.message });
          getUsers();
        } else {
          dispatch({ type: THROW_ERROR, payload: res.body.message });
        }
      } else {
        dispatch({ type: THROW_ERROR, payload: err.data.message });
        dispatch({ type: IS_LOADING, payload: false });
      }
      setIsLoading(false);
    });
};

export const getExportUser = (url) => async () => {
  const queryParam = url ? `?${url}` : "";

  return superagent
    .get(`${base_url}admin/export${queryParam}`)
    .set("accept", "application/json")
    .set("Authorization", cookie.get("user_token"))
    .responseType("blob")
    .end((_err, res) => {
      if (res) {
        saveAs(res.body, "users.xlsx");
      }
    });
};
